import { Component, Input } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { LabelComponent } from '../../../../../../../common/label/label.component';

@Component({
  selector: 'app-irspa-detailed-information-about-cadastral-plots-preview',
  standalone: true,
  imports: [
    LabelComponent
  ],
  templateUrl: './irspa-detailed-information-about-cadastral-plots-preview.component.html'
})
export class IrspaDetailedInformationAboutCadastralPlotsPreviewComponent {
  @Input()
  public application: ApplicationAppEntityApplicationRead | null = null;
}
